// extracted by mini-css-extract-plugin
module.exports = {"OrdersListHeading":"styles_OrdersListHeading__1QC95"};